module.exports = __webpack_public_path__ + "icon-512x512.png";